<template>
  <div class="online-box">
    <div class="online-input">
      <div>充值金额</div>
      <div class="online-enter">
        <div class="online-unit">¥</div>
        <!-- <cube-input :type="'number'" v-model="balance"></cube-input> -->
        <number-input class="cube-input" placeholder="请输入充值金额" :controls="false" :precision="2" :min="0" v-model="balance"></number-input>
      </div>
    </div>

    <div class="pay-box">
      <div class="pay-title">付款方式</div>
      <ul class="pay-list">
        <li v-for="item in payList" :key="item.value" @click="changePay(item)">
          <i class="iconfont pay-icon" :class="item.icon" :style="`color:${item.color}`"></i>
          <span class="pay-name">{{item.name}}</span>
          <i class="iconfont iconduigou" v-show="item.value === currentPay"></i>
        </li>
      </ul>
    </div>
    <div class="pay-btn">
      <Button @click="pay">支付</Button>
    </div>
    <charge-modal @confirm="confirm" @cancel="cancel"></charge-modal>
  </div>
</template>

<script>
import { Style, Button, Toast } from 'cube-ui';
import VueNumericInput from 'vue-numeric-input';
import apis from 'api/index';
import chargeModal from './charge-modal.vue';
import { mapState } from 'vuex';
import { commonMixin } from 'common/js/mixin';

export default {
  mixins: [commonMixin],
  components: {
    NumberInput: VueNumericInput,
    Button,
    chargeModal
  },
  data() {
    return {
      payList: [
        { name: '微信支付', value: 1 , icon: 'iconweixinzhifu', color: '#09BB07'},
        // { name: '支付宝', value: 2, icon: 'iconzhifubao', color: '#00AAEE' }
      ],
      currentPay: 1,
      balance: null,
      mwebUrl: '',
      payId: null,
    }
  },
  computed: {
    ...mapState(['token'])
  },
  mounted() {
    if(this.$route.query.payId) {
      this.$modal.show('charge-modal');
    }
  },
  methods: {
    changePay(item) {
      this.currentPay = item.value;
    },
    pay() {
      if(!this.balance) {
        this.showToast('请正确填写');
        return false;
      }
      if(this.currentPay === 1) {    // 微信支付
        let params = {
          price: this.balance,
          tradeType: "MWEB"
        }
        apis.wxPay(JSON.stringify(params)).then(res => {
          this.mwebUrl = res.mwebUrl;
          this.payId = res.id;
          let replaceUrl = `${this.mwebUrl}&redirect_url=${encodeURIComponent(`http://console.ovopark.com/webview/billing-app/charge/?token=${this.token}&payId=${this.payId}`)}`;
          window.location.href = replaceUrl;
          // this.sendPayUrl(replaceUrl);
        });
      }
    },
    async confirm() {
      try {
        const res = await apis.payDetail({id: this.$route.query.payId});
        if(res.status === 3) { // 支付成功跳到首页
          this.$router.push({name: 'home'});
        } else if (res.status === 2) { // 待付款
          this.balance = res.price;
          this.$modal.hide('charge-modal');
          this.showToast('支付未付款，如要充值请重新支付');
        }
      } catch(err) {
        console.error(err);
      }
    },
    async cancel() {
      try {
        const res = await apis.payDetail({id: this.$route.query.payId});
        if(res.status === 3) {
          this.$modal.hide('charge-modal');
          this.showToast('支付成功', 'success');
        } else if (res.status === 2) {
          this.balance = res.price;
          this.$modal.hide('charge-modal');
          this.showToast('支付未付款，如要充值请重新支付');
        }
      } catch(err) {
        console.error(err);
      }
    }
  },
}
</script>


<style lang="scss" scoped>
.online-box {
  position: absolute;
  top: 106px;
  left: 0;
  width: 100%;
  bottom: 0;
  .online-input {
    width: 100%;
    height: 78px;
    background: #fff;
    padding: 20px 10px;
  }
  .online-enter {
    margin-top: 20px;
    display: flex;
    .online-unit {
      line-height: 40px;
      font-size: 22px;
      color: #333;
      margin:0 20px 0 5px;
    }
    
  }
  .pay-box {
    width: 92%;
    background: #fff;
    margin-top: 20px;
    padding: 0px 4%;
    .pay-title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
    }
    .pay-list {
      width: 100%;
      > li {
        height: 60px;
        line-height: 60px;
        border-top: 1px solid #F2F2F2;
        .pay-icon {
          font-size: 26px;
          margin-right: 15px;
          vertical-align: middle;
        }
        .pay-name {
          font-size: 16px;
          color: #333;
          line-height: 60px;
        }
        .iconduigou {
          float: right;
          color: #f90;
          margin-right: 10px;
        }
      }
    }
  }
  .pay-btn {
    width: 92%;
    height: 80px;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px 4%;
  }
}
</style>

<style lang="scss">
.online-box {
  .cube-input {
    width: 300px;
    height: 40px;
    .numeric-input {
      width: 100%;
      height: 40px;
      background: #F7F7F7;
      padding-right: 40px;
      border-color: #E6E6E6;
      outline: none;
      -webkit-appearance: none;
    }
  }
}
</style>



